export default {
  labels: {
    free_items: 'Ilmaiset tuotteet',
    bogo: 'Osta yksi, saat yhden ilmaiseksi',
    order_again: 'Tilaa uudelleen',
  },
};
